// extracted by mini-css-extract-plugin
export default {"panel":"BjXjPvEL","active":"XdqwRPem","disabled":"xm8kfApY","text":"fvrci5xJ","panel-title":"trm30pQe","image":"lUEo03qA"};